import './Header.css';

import { useTranslation } from 'react-i18next';


function Header() {

  const { t, i18n } = useTranslation();


  const changeLanguage = (language) => {

    i18n.changeLanguage(language);

  };


  return (

    <header className="header">


      <div className="header-container">


        <a href="#home" className="logo">

          BrightWeekdays

        </a>



        <nav className="navigation">


          <ul>


            <li>

              <a href="#about">

                {t('navigation.about')}

              </a>

            </li>



            <li>

              <a href="#experience">

                {t('navigation.experience')}

              </a>

            </li>



            <li>

              <a href="#portfolio">

                {t('navigation.portfolio')}

              </a>

            </li>



            <li>

              <a href="#contact">

                {t('navigation.contact')}

              </a>

            </li>


          </ul>


        </nav>





        <div className="language-switcher">


          <button

            onClick={() => changeLanguage('en')}

            className={
              i18n.language.startsWith('en')
                ? 'active'
                : ''
            }

          >

            🇬🇧 EN

          </button>



          <span>
            |
          </span>



          <button

            onClick={() => changeLanguage('ru')}

            className={
              i18n.language.startsWith('ru')
                ? 'active'
                : ''
            }

          >

            🇷🇺 RU

          </button>



        </div>



      </div>


    </header>

  );

}


export default Header;